export const enum COMPANY_ID_MAP {
  DINAMICA = 7
}